import React from "react";
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

export const LoaderGunSettings = (props) => {
    let { tpsLimit, duration, onChange } = props;

    return (
        <div className='my-28'>
            <div className='my-24'>
                <TextField
                    id="standard-number-lg"
                    label="TPS"
                    error={tpsLimit > 10000 || tpsLimit < 1}
                    helperText={tpsLimit > 10000 || tpsLimit < 1 ? `TPS limit must be between 1 and 10000` : ''}
                    value={tpsLimit}
                    onChange={(e) => onChange(parseInt(e.target.value), 'lgTpsLimit')}
                    type="number"
                    margin="normal"
                />
            </div>
            <div className='my-24'>
                <TextField
                    id="standard-number-lg"
                    label="Duration"
                    error={duration > 10000 || duration < 1}
                    helperText={duration > 10000 || duration < 1 ? `Duration limit must be between 1 and 10000` : ''}
                    value={duration}
                    onChange={(e) => onChange(parseInt(e.target.value), 'lgDurationLimit')}
                    type="number"
                    margin="normal"
                />
            </div>
        </div>
    )
};

LoaderGunSettings.propTypes = {
    tpsLimit: PropTypes.PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    duration: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};


// WEBPACK FOOTER //
// ./src/main/content/settings/settings-sections/LoaderGunSettings.js